var _circle, _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100Pros(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#ECF9FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5397_18311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0863 14.8525L31.9096 12.1424C29.6966 11.4089 27.306 11.4089 25.093 12.1424L16.9163 14.8525C16.0435 15.1418 15.284 15.6989 14.7457 16.4445C14.2075 17.19 13.9178 18.0863 13.918 19.0058V28.4996C13.918 39.4721 27.3346 45.5314 27.9092 45.7837L28.1311 45.8821C28.3205 45.9661 28.5345 45.9766 28.7312 45.9114L28.9621 45.8348C29.5396 45.6423 43.0846 41.0077 43.0846 28.4996V19.0058C43.0848 18.0863 42.7951 17.19 42.2569 16.4445C41.7186 15.6989 40.9592 15.1418 40.0863 14.8525Z",
    fill: "#4FC0CF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.25 19.6738C45.9042 19.6739 46.9465 19.8146 47.7471 20.4951L47.9033 20.6387L48.043 20.7861C48.7087 21.5362 48.8956 22.4954 48.8975 23.1934C48.8994 23.9369 48.693 24.9856 47.9082 25.7588L37.1084 36.3975C35.8026 37.6838 33.6974 37.6838 32.3916 36.3975L26.9922 31.0781C26.1819 30.2799 26.0001 29.1727 26 28.4561C25.9999 27.7395 26.1815 26.6316 26.9922 25.833C27.5688 25.2652 28.3447 24.8935 29.1113 24.7627C29.8099 24.6436 30.8674 24.6778 31.7334 25.4082L31.9033 25.5645L34.915 28.5312L42.5664 20.668L42.5967 20.6387C43.4135 19.834 44.5522 19.6738 45.25 19.6738Z",
    fill: "#7ED957",
    stroke: "#ECF9FE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.25 21.1738C45.7942 21.1739 46.4487 21.3114 46.8506 21.707C47.2432 22.0938 47.3961 22.6829 47.3975 23.1973C47.3988 23.7114 47.2493 24.3014 46.8555 24.6895L36.0557 35.3291C35.3338 36.0402 34.1662 36.0402 33.4443 35.3291L28.0449 30.0098C27.6447 29.6155 27.5001 28.9869 27.5 28.4561C27.4999 27.9252 27.6436 27.2958 28.0439 26.9014C28.3857 26.5647 28.8759 26.3244 29.3633 26.2412C29.8453 26.159 30.4294 26.218 30.8506 26.6328L34.9375 30.6582L43.6416 21.7148L43.6494 21.707C44.0513 21.3112 44.7057 21.1738 45.25 21.1738Z",
    fill: "#7ED957",
    stroke: "#7ED957",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5397_18311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100Pros);
export default __webpack_public_path__ + "static/media/100Pros.0fa7b5fe5cf14e6f05a41544d1c8ad9c.svg";
export { ForwardRef as ReactComponent };